import { __awaiter } from "tslib";
import { ResourceService } from '../../../http/resource/resource.service';
import { HttpClient } from '@angular/common/http';
import { FieldsSerializer } from './fields.serializer';
import { environment } from '../../../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class FieldStandardService extends ResourceService {
    constructor(httpClient) {
        super(httpClient, `${environment.API}`, 'selective-process/standard-fields', new FieldsSerializer());
        this.allFields = [];
    }
    getFields() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.allFields.length === 0) {
                yield this.loadFields();
            }
            return this.allFields;
        });
    }
    setFields(fields) {
        this.allFields = fields;
    }
    loadFields() {
        return __awaiter(this, void 0, void 0, function* () {
            const fields = yield this.getAllFieldsPromise();
            if (fields) {
                this.setFields(fields);
            }
        });
    }
    getAllFieldsPromise() {
        return this.createArrayNoParam().toPromise();
    }
}
FieldStandardService.ɵfac = function FieldStandardService_Factory(t) { return new (t || FieldStandardService)(i0.ɵɵinject(i1.HttpClient)); };
FieldStandardService.ɵprov = i0.ɵɵdefineInjectable({ token: FieldStandardService, factory: FieldStandardService.ɵfac, providedIn: 'root' });
//# sourceMappingURL=fields-standard.service.js.map